import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import useColor from '../../hooks/useColor'

export const Avatar = ({ size, initials, src, className, ...props }) => {
  const classes = ({
    '2xl': 'w-16 h-16 text-2xl',
    xl: 'w-14 h-14 text-xl',
    lg: 'w-12 h-12 text-lg',
    md: 'w-10 h-10 text-base',
    sm: 'w-8 h-8 text-sm',
    xs: 'w-6 h-6 text-xs',
  })[size] || 'w-10 h-10 text-base'

  const backgroundColor = useColor(initials || null)

  return (
    <div
      style={{ backgroundColor: initials ? backgroundColor : undefined }}
      className={classNames([
        'relative',
        'flex',
        'justify-center',
        'items-center',
        'rounded-full',
        'border',
        'border-white',
      ],
        classes,
        {
          'bg-gray-300': !initials,
        },
        className,
      )}
      {...props}
    >
      { src ? (
        <img
          src={src}
          className="rounded-full"
        />
      ) : initials ? (
        <span className="text-white uppercase">
          { initials }
        </span>
      ) : (
        <FontAwesomeIcon
          className="text-white"
          icon="fa-solid fa-user"
        />
      ) }
    </div>
  )
}

export default Avatar
